import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { serverDev, paylocSearchEndpoint } from '../constants';
import { Observable, of } from 'rxjs';
import { FlashMessagesService } from '../shared/flash-messages/service/flash.messages.service';

@Injectable()
export class GenericService<T> {

    private server: string;
    private endpoint: string;
    private actionUrl: string;
    private token: string;

    constructor(
        protected http: HttpClient,
        _endpoint: string,
        protected flashMessagesService: FlashMessagesService

    ) {
        this.server = serverDev;
        this.endpoint = _endpoint;
        this.actionUrl = this.server + this.endpoint;
    }

    public getAll(): Observable<T> {
        //  console.log('GenericService => getAll => ' + this.actionUrl);
        return this.http.get<T>(this.actionUrl);
    }

    public getPage(page: number): Observable<T> {
        //  console.log('GenericService => getPage => ' + this.actionUrl);
        return this.http.get<T>(this.actionUrl + '?page=' + page);
    }

    public getSingle(id: number): Observable<T> {
        //  console.log('GenericService => getSingle');
        return this.http.get<T>(this.actionUrl + id);
    }

    public search<T>(item: T, page: number): Observable<T> {
        return this.http.post<T>(this.actionUrl + paylocSearchEndpoint + '?page=' + page, item);
    }

    public add(item: T): Observable<T> {
        // console.log('GenericService => add');
        // console.log(item);
        return this.http.post<T>(this.actionUrl, item);
    }

    public update(id: number, itemToUpdate: T): Observable<T> {
        // console.log('GenericService => update');
        return this.http.put<T>(this.actionUrl + id, itemToUpdate);
    }

    public reactivate(id: number, itemToUpdate: T): Observable<T> {
      return this.http.put<T>(this.actionUrl + id + '/activate', itemToUpdate);
    }

    public delete(id: number): Observable<T> {
        // console.log('GenericService => delete');
        return this.http.delete<T>(this.actionUrl + id);
    }

    /**
   * Handle Http operation that failed.
   * Let the app continue.
   * @param operation - name of the operation that failed
   * @param result - optional value to return as the observable result
   */
    protected handleErrors<T>(operation = 'operation', result?: T) {
        return (error: any): Observable<T> => {

            // TODO: send the error to remote logging infrastructure
            console.log(error.message);
            // this.flashMessagesService.error(operation); // log to console instead
            this.flashMessagesService.error(error.message);
            // TODO: better job of transforming error for user consumption
            this.log(`${operation} failed: ${error.message}`);

            // Let the app keep running by returning an empty result.
            return of(result as T);
        };
    }

    /**
 * Handle Http operation that failed.
 * Let the app continue.
 * @param operation - name of the operation that failed
 * @param error -  value to return as the observable result
 */
    public handleError<T>(operation = 'operation', error: any) {

        this.flashMessagesService.error(`${operation} failed: ${error.message}`);

    }
    /**
     * Log a message with the MessageService
     */
    protected log(message: string) {
        console.log(this.constructor.name + `: ${message}`);
        // this.flashMessagesService.error(this.constructor.name + `: ${message}`);
    }

}
